var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgViewLeave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 10,
    viewBox: "0 0 12 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7341_38865)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.955 4.825C10.97 3.04583 8.75 1.25 6 1.25C3.25 1.25 1.03 3.04583 0.045 4.825C0.0153367 4.88003 0 4.93967 0 5C0 5.06033 0.0153367 5.11997 0.045 5.175C1.03 6.95417 3.25 8.75 6 8.75C8.75 8.75 10.97 6.95417 11.955 5.175C11.9847 5.11997 12 5.06033 12 5C12 4.93967 11.9847 4.88003 11.955 4.825ZM6 7.08333C5.50555 7.08333 5.0222 6.96115 4.61107 6.73223C4.19995 6.50331 3.87952 6.17794 3.6903 5.79726C3.50108 5.41658 3.45157 4.99769 3.54804 4.59356C3.6445 4.18943 3.8826 3.81822 4.23223 3.52686C4.58186 3.2355 5.02732 3.03708 5.51227 2.9567C5.99723 2.87631 6.49989 2.91757 6.95671 3.07525C7.41352 3.23293 7.80397 3.49996 8.07867 3.84256C8.35338 4.18516 8.5 4.58796 8.5 5C8.49921 5.55233 8.23556 6.08185 7.76689 6.47241C7.29822 6.86297 6.6628 7.08267 6 7.08333Z",
    fill: "#EE4B22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 6.25C6.82843 6.25 7.5 5.69036 7.5 5C7.5 4.30964 6.82843 3.75 6 3.75C5.17157 3.75 4.5 4.30964 4.5 5C4.5 5.69036 5.17157 6.25 6 6.25Z",
    fill: "#EE4B22"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7341_38865"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 10,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewLeave);
export default __webpack_public_path__ + "static/media/View-leave.7cf46d4df4119287e70e3bab0d60525b.svg";
export { ForwardRef as ReactComponent };